import { Form, InputNumber } from '@arco-design/web-react'
import JsonField, { validateJson } from '../JsonField'
import InstantSwitch from '../InstantSwitch'
import SettingSectionCard from '../SettingSectionCard'
import type { OptionsAPI } from '../useOptions'

const KEYS = [
  'global.pass_through_request_enabled',
  'global.thinking_model_blacklist',
  'global.chat_completions_to_responses_policy',
  'general_setting.ping_interval_enabled',
  'general_setting.ping_interval_seconds',
]

export default function GlobalModelSection({ options }: { options: OptionsAPI }) {
  const { get, getNumber, patch } = options

  const validate = () => {
    for (const label of ['global.thinking_model_blacklist', 'global.chat_completions_to_responses_policy']) {
      const msg = validateJson(get(label))
      if (msg) return `${label}: ${msg}`
    }
    return null
  }

  return (
    <SettingSectionCard title="全局模型" keys={KEYS} options={options} validate={validate}>
      <Form layout="vertical">
        <Form.Item label="透传原始请求体">
          <InstantSwitch options={options} optionKey="global.pass_through_request_enabled" />
        </Form.Item>
        <Form.Item label="Thinking 模型黑名单 JSON">
          <JsonField
            value={get('global.thinking_model_blacklist', '[]')}
            onChange={(v) => patch({ 'global.thinking_model_blacklist': v })}
            rows={4}
          />
        </Form.Item>
        <Form.Item label="Chat Completions 转 Responses 策略 JSON">
          <JsonField
            value={get('global.chat_completions_to_responses_policy', '{}')}
            onChange={(v) => patch({ 'global.chat_completions_to_responses_policy': v })}
            rows={6}
          />
        </Form.Item>
        <div className="grid md:grid-cols-2 gap-3">
          <Form.Item label="SSE Ping 间隔开关">
            <InstantSwitch options={options} optionKey="general_setting.ping_interval_enabled" />
          </Form.Item>
          <Form.Item label="Ping 间隔（秒）">
            <InputNumber
              style={{ width: 240 }}
              value={getNumber('general_setting.ping_interval_seconds', 60)}
              onChange={(v) => patch({ 'general_setting.ping_interval_seconds': v ?? 60 })}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
